
export default {
  name: 'TextBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    classes() {
      return {
        [this.blok.fontweight]: !!this.blok.fontweight,
        [this.blok.typography]: !!this.blok.typography,
        'text-center': !!this.blok.center,
        'font-italic': !!this.blok.italic,
        [this.blok.customClasses]: !!this.blok.customClasses,
        'text-block': !!this.blok.block,
        'mx-auto': this.blok.center && this.blok.maxWidth
      }
    },
    tag() {
      return this.blok.htmlTag ?? 'p'
    },
    margin() {
      const spacings = []
      const blok = this.blok
      spacings.push(this.toString(blok.mt, 't'))
      spacings.push(this.toString(blok.mr, 'r'))
      spacings.push(this.toString(blok.mb, 'b'))
      spacings.push(this.toString(blok.ml, 'l'))
      spacings.push(this.toString(blok.md_mt, 't', 'md'))
      spacings.push(this.toString(blok.md_mr, 'r', 'md'))
      spacings.push(this.toString(blok.md_mb, 'b', 'md'))
      spacings.push(this.toString(blok.md_ml, 'l', 'md'))
      return spacings.filter((n) => n)
    },
    style() {
      if (this.blok.maxWidth) {
        return {
          maxWidth: `${this.blok.maxWidth}px`,
        }
      }
      return {}
    },
  },
  methods: {
    toString(value, direction, breakpoint) {
      if (!value) return
      const usePadding = value > 0 && this.blok.padding
      let prefix = usePadding ? 'p' : 'm'
      prefix += direction ?? 'a'
      prefix += '-'
      if (breakpoint) {
        prefix += `${breakpoint}-`
      }
      if (value > 0) return prefix + value
      return prefix + 'n' + Math.abs(value)
    },
  },
}
